import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { isMobileMode, isNativeOfflineShell } from 'helpers/core/url';

/**
 * True only when URL param `mobile` equals `'true'`.
 * Used for mobile UI and API selection, not offline storage or queueing.
 */
export function useIsMobileMode() {
  const { search, hash } = useLocation();

  const mobileMode = useMemo(() => isMobileMode(), [search, hash]);

  return { isMobileMode: mobileMode };
}

/**
 * True only when native opened the on-device cache
 * (`mobile=true` and `offlineShell=true`).
 */
export function useIsOfflineShellMode() {
  const { search, hash } = useLocation();

  const offlineShellMode = useMemo(
    () => isNativeOfflineShell(),
    [search, hash]
  );

  return { isOfflineShellMode: offlineShellMode };
}
